import React, { useState } from 'react'
import copyToClipboard from 'helpers/copyToClipboard'
import useSafeState from 'hooks/useSafeState'
import styled from 'styled-components'
import { Checkbox } from 'components/forms'
import { StyledInnerElement, PositionedColorTag, RightSideContainer } from 'components/Tree/nodes/common'

import { ReactComponent as Android } from './icons/android.svg'
import { ReactComponent as MobileWaiter } from './icons/mobileWaiter.svg'
import { ReactComponent as KDS } from './icons/kds.svg'
import { ReactComponent as Middle } from 'components/Tree/icons/middle.svg'
import { ReactComponent as Bottom } from 'components/Tree/icons/bottom.svg'


const IconContainer = styled.div`
	position: relative;
	cursor: pointer;
`

const Tooltip = styled.div`
	position: absolute;
	bottom: calc(100% + 4px);
	right: 0;
	padding: 8px;
	border-radius: 3px;
  box-shadow: 0 1px 2px 0 rgba(90, 90, 90, 0.12);
  border: solid 0.2px #dadada;
  background-color: #f4f4f4;
`

const CashRegisterIcon = ({ deviceType, tooltipText, onClick }) => {
	const [displayTooltip, setDisplayTooltip] = useState(false)
	const [displayText, setDisplayText] = useSafeState(tooltipText)

	const handleClick = e => {
		e.stopPropagation()
		if(onClick) {
			onClick(e)
		} else if(tooltipText) {
			copyToClipboard(tooltipText)
			setDisplayText('Copied!')
			setTimeout(() => {
				setDisplayText(tooltipText)
			}, 2000)
		}
	}

	let Ico = null
	switch(deviceType) {
		case 'SMART_CHECKOUT': Ico = Android
			break
		case 'SELF_CHECKOUT': Ico = Android
			break
		case 'MOBILE_WAITER': Ico = MobileWaiter
			break
		case 'KDS': Ico = KDS
			break
		default:
	}

	return(!Ico ? null :
		<IconContainer>
			<Ico
				onClick={handleClick}
				onMouseOver={() => setDisplayTooltip(true)}
				onMouseOut={() => setDisplayTooltip(false)}
			/>
			{displayTooltip && tooltipText &&
				<Tooltip>{displayText}</Tooltip>
			}
		</IconContainer>
	)
}

const CashRegister = ({ onOldCrIconClick, label, status, toggleActive, isOpened, toggleOpened, isSelected, isCheckable, isLastChild, handleSelect, nodeData = {}, checkOnSelect }) => {
	const handleOldCrIconClick = e => {
		if(onOldCrIconClick) {
			onOldCrIconClick(nodeData)
		}
	}
	return(
		<li>
			<StyledInnerElement onClick={handleSelect} paddingLeft={48} isSelectable={checkOnSelect} noBorder errorBackground={nodeData.outOfOrder}>
				{checkOnSelect && <PositionedColorTag color={isSelected ? '#3c4e5a' : null}/>}
				{isLastChild ?
					<Bottom style={{ marginBottom: 'auto', marginRight: '5px' }}/> :
					<Middle style={{ marginRight: '5px' }}/>
				}
				{isCheckable ? <Checkbox
					noForm
					stopPropagation={true}
					onChange={toggleActive}
					checked={status === 'ACTIVE'}
					indeterminate={status === 'PARTIAL_ACTIVE'}
					field='active'
					label={label}
					inline
				/> : label}
				<RightSideContainer width='30px'>
					{nodeData.deviceType !== 'OLD_CASHREGISTER' &&
						<CashRegisterIcon tooltipText={nodeData.hardwareId} deviceType={nodeData.deviceType} />
					}
					{isSelected && nodeData.deviceType === 'OLD_CASHREGISTER' &&
						<CashRegisterIcon tooltipText='Convert to Android' deviceType='SMART_CHECKOUT' onClick={handleOldCrIconClick} />
					}
				</RightSideContainer>
			</StyledInnerElement>
		</li>
	)
}

export default CashRegister
